import { FileText, UploadCloud } from "lucide-react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import {
  useSpyImport,
  ImportTabPanel,
  ImportProgress,
} from "@/components/spy-import";

export default function ImportPage() {
  const { loading, progress, status, handleFileSelect } = useSpyImport();

  return (
    <div className="flex-1 overflow-x-hidden w-full">
      <div className="mb-6">
        <h1 className="text-3xl font-bold tracking-tight">Data Import</h1>
        <p className="text-muted-foreground">
          Loading SpySerp rankings and pages directory into the database.
        </p>
      </div>

      <Tabs defaultValue="spyserp" className="w-full mb-6">
        <TabsList className="grid w-full grid-cols-2 mb-4">
          <TabsTrigger className="cursor-pointer" value="spyserp">
            SpySerp Rankings (Weekly)
          </TabsTrigger>
          <TabsTrigger className="cursor-pointer" value="pages">
            Pages Directory (Once)
          </TabsTrigger>
        </TabsList>

        <TabsContent value="spyserp">
          <ImportTabPanel
            title="Import SpySerp Rankings"
            description="Upload a weekly CSV file. Expected columns: SERP URL, Domains, Keywords, Rank, Check Date, Location."
            icon={UploadCloud}
            loading={loading}
            onFileSelect={(e, ref) => handleFileSelect(e, "spyserp", ref)}
          />
        </TabsContent>

        <TabsContent value="pages">
          <ImportTabPanel
            title="Import Pages Directory"
            description="Upload a CSV file with the structure of websites. Expected columns: domain, Public URL, lang_page, geo_page, brand_keyword."
            icon={FileText}
            loading={loading}
            onFileSelect={(e, ref) => handleFileSelect(e, "pages", ref)}
          />
        </TabsContent>
      </Tabs>

      <ImportProgress loading={loading} progress={progress} status={status} />
    </div>
  );
}
